export default "__VITE_ASSET__a1f8983d__"